import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { SystemFlow } from './SystemFlow';
import { getWhatsAppLink } from '../../utils/whatsapp';
const PRIMARY_WHATSAPP_MESSAGE = 'Hola, equipo de ORIGEN. Quiero mejorar mi presencia digital.';
const SECONDARY_WHATSAPP_MESSAGE = 'Hola, equipo de ORIGEN. Quiero automatizar mi empresa.';
export function Hero() {
  return <section className="min-h-[100vh] pt-[68px] md:pt-[78px] bg-arena flex items-center" data-id="element-89" data-mp="apbhx8xv1m7z">
      <div className="max-w-[1240px] mx-auto w-full px-6 md:px-16 py-14 md:py-0" data-id="element-90" data-mp="5ofeewhf8233">
        <div className="grid grid-cols-1 md:grid-cols-[55%_45%] gap-16 md:gap-8 items-center min-h-[calc(100vh-68px)] md:min-h-[calc(100vh-78px)]" data-id="element-91" data-mp="pudsvy9bge4">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col items-start" data-id="element-92" data-mp="1v4ergoo5ubo0">
            <span className="font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-93" data-mp="1rx0d9qz2ti8q">
              ORIGEN / DIGITAL SYSTEMS
            </span>

            <h1 className="font-display text-[40px] md:text-[68px] font-medium text-carbon leading-[1.02] tracking-[-0.02em] max-w-[580px] mb-6" data-id="element-94" data-mp="1hwg7qc4ixrkp">
              Tu presencia digital debería trabajar por tu empresa.
            </h1>

            <p className="font-body text-[17px] md:text-[19px] text-carbon/65 leading-[1.6] max-w-[480px] mb-9" data-id="element-95" data-mp="2aldr6ikh1uf1">
              Diseñamos mejores experiencias digitales y automatizamos los
              procesos que ocurren después: atención, calificación, agenda,
              seguimiento y conversión.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto mb-8" data-id="element-96" data-mp="2ojljueah69ke">
              <a href={getWhatsAppLink(PRIMARY_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-medium text-[15px] px-7 py-3.5 rounded-[6px] hover:bg-verde-hover transition-colors duration-200" data-id="element-97" data-mp="338eqr81u43vt">
                Mejorar mi presencia digital{' '}
                <ArrowRight size={16} className="ml-2" data-id="element-98" data-mp="2k9sqtwi20ith" />
              </a>
              <a href={getWhatsAppLink(SECONDARY_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-transparent text-carbon border border-carbon/20 font-display font-medium text-[15px] px-7 py-3.5 rounded-[6px] hover:border-carbon/40 transition-colors duration-200" data-id="element-99" data-mp="2fisv2uko86sk">
                Automatizar mi empresa <ArrowRight size={16} className="ml-2" data-id="element-100" data-mp="1wkzqzoyb9qtl" />
              </a>
            </div>

            <a href="#como-funciona" className="inline-flex items-center gap-1.5 font-body text-[13px] text-carbon/40 hover:text-carbon/70 transition-colors duration-150" data-id="element-101" data-mp="c2p6nt12xuqb">
              Ver cómo funciona <ChevronDown size={14} data-id="element-102" data-mp="m0lh0im70lnd" />
            </a>

            <p className="font-body text-[13px] text-carbon/35 tracking-wide mt-8" data-id="element-103" data-mp="q272gscsm896">
              WEB · WHATSAPP · IA · CRM · AGENDA · VOICE
            </p>
          </motion.div>

          {/* Right Column - System trace */}
          <div className="w-full flex items-center justify-center" data-id="element-104" data-mp="3ugopurp1kgda">
            <SystemFlow data-id="element-105" data-mp="2bktmyuysjy4" />
          </div>
        </div>
      </div>
    </section>;
}